class Cookies
{
	constructor() {
		this.cookies = document.querySelector('.cookies');
		if (this.cookies !== null){
			this.submitBtn = this.cookies.querySelector('.btn');
			this.initCookiesConfirmation();
		}
	}

	initCookiesConfirmation(){
		this.submitBtn.addEventListener('click', (e) => {
			e.preventDefault();

			let date = new Date();
			date.setFullYear(date.getFullYear() + 10);
			document.cookie = 'eu-cookies=1; path=/; expires=' + date.toGMTString();
			this.cookies.style.display = 'none';
		});
	}
}

export default Cookies;
